/**
 * Homepage: light header (white logo/links) while the Coeur hero is behind the header;
 * restores default dark Coeur header after scrolling past the hero.
 *
 * All pages: shrinks the header (wordmark, menu icon, header bar height) once
 * the user has scrolled past a small threshold, via the header-shrink class.
 */
(function () {
  const LIGHT = 'template-index--header-light';
  const SHRINK = 'header-shrink';
  const isHomepage = document.body.classList.contains('template-index');

  function headerBandBottom() {
    const group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return 0;
    return Math.ceil(group.getBoundingClientRect().bottom);
  }

  function update() {
    // While the mobile/tablet menu drawer holds the scroll lock (body is
    // position:fixed with a negative top offset), window.pageYOffset /
    // scrollTop read back as 0 regardless of actual scroll position — and on
    // many mobile browsers, locking scroll this way also fires a stray
    // scroll/resize event. Recalculating here would incorrectly remove
    // header-shrink and pop the header back to full size *after* the menu
    // drawer's top offset has already been locked in against the shrunk
    // header height, leaving the now-taller header overlapping the drawer.
    // Skip entirely while locked; closing the drawer restores the real
    // scroll position and its own scroll event re-triggers this normally.
    if (document.body.classList.contains('coeur-scroll-locked')) return;

    // Shrink: works on every page, based on scroll position past a small threshold
    const scrolled = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle(SHRINK, scrolled > 40);

    // Light/dark: homepage only, tied to the hero element
    if (!isHomepage) return;

    const hero = document.querySelector('.coeur-home-landing');
    if (!hero) {
      document.body.classList.remove(LIGHT);
      return;
    }
    const bottom = hero.getBoundingClientRect().bottom;
    const threshold = headerBandBottom() + 2;
    const pastHero = bottom <= threshold;
    document.body.classList.toggle(LIGHT, !pastHero);
  }

  let scheduled = false;
  function onScrollOrResize() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(update));
})();
